import {omit} from 'lodash';

const DETAULT_USER =  {
	id: null,
	name: null,
	email: null
}

export default (state=DETAULT_USER, action) => {
	let newState = Object.assign({}, state);
	switch(action.type){
		case "LOG_USER_IN":
			return omit({...action},['type']);

		default:
			return newState;
	}
}






// WEBPACK FOOTER //
// ./src/reducers/user.js